/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar9 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar9", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 14.888672 14.308594 C 15.884672 14.308594 16.70175 14.713172 17.21875 15.451172 C 17.69275 16.086172 17.941406 16.959141 17.941406 17.994141 C 17.942406 20.302141 16.775859 21.728516 14.880859 21.728516 C 13.464859 21.728516 12.346156 20.904891 12.160156 19.712891 L 13.912109 19.712891 C 14.024109 20.103891 14.411625 20.351562 14.890625 20.351562 C 15.759625 20.351562 16.310094 19.454391 16.246094 18.150391 L 16.197266 18.150391 L 16.154297 18.150391 C 15.837297 18.804391 15.206625 19.171875 14.390625 19.171875 C 13.057625 19.171875 12.072266 18.185656 12.072266 16.847656 C 12.072266 15.363656 13.238672 14.308594 14.888672 14.308594 z M 14.904297 15.689453 C 14.279297 15.689453 13.792969 16.171969 13.792969 16.792969 C 13.792969 17.417969 14.270297 17.886719 14.904297 17.886719 C 15.534297 17.886719 16.013672 17.418828 16.013672 16.798828 C 16.013672 16.172828 15.529297 15.689453 14.904297 15.689453 z" />
      </svg>
    );
  }
}

IconCalendar9.defaultProps = {
  className: null
};

IconCalendar9.propTypes = {
  className: PropTypes.string
};

export default IconCalendar9;
